import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { MAKE_OFFER } from "../../../../../services/ApiCalls";
import styles from "./MakeOffer.module.scss";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const MakeOfferPop = ({ Offer, setOffer, makeOfferHandler }) => {
  const navigate = useNavigate();
  const [price, setPrice] = useState("");
  // const [offerMade, setOfferMade] = useState(userHasMadeOffer || false);
  const { id } = useParams();
  const handleOffer = () => setOffer(!Offer);

  const offerHandler = async (e) => {
    e.preventDefault();
    if (!price) {
      return toast.error("Please enter an offer amount");
    }
    const body = { bookingId: id, offerAmount: price };
    try {
      const res = await MAKE_OFFER(body);
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        // setOfferMade(true);
        navigate("/booking/booking-request");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
    makeOfferHandler();
  };

  return (
    <>
      <Modal
        show={Offer}
        className={`${styles.makeOffer} transparentModal`}
        onHide={handleOffer}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>
          <Button
            onClick={handleOffer}
            className="border-0 p-0 position-absolute"
            style={{ right: 10, top: 10 }}
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="21"
              viewBox="0 0 15 21"
              fill="none"
            >
              <path
                d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
                fill="black"
              />
            </svg>
          </Button>
          <Form onSubmit={offerHandler}>
            <Row>
              <Col lg="12" className="my-2">
                <label
                  htmlFor="offer-amount"
                  className="form-label fw-sbold m-0 pb-1"
                >
                  Make an Offer
                </label>
                <input
                  type="number"
                  placeholder="$ 10.00"
                  className="form-control"
                  id="offer-amount"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </Col>
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-end gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    onClick={handleOffer}
                    type="button"
                    // disabled={offerMade}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    // disabled={offerMade}
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MakeOfferPop;
